/*=========================================================================================
  File Name: moduleCourseRequestActions.js
  Description: CourseRequest Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      
      axios.post("api/CourseRequest/AddCourseRequest", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  AddCourseRequestForCustomer(context, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/AddCourseRequestForCustomer", item).then((response)=>{
        resolve(response)
      }).catch((error) => { reject(error) });
    });
   
  },

  fetchDataListItems({ commit }) {
    
    return new Promise((resolve, reject) => {
      axios.get("api/CourseRequest/GetAll")
        .then((response) => {
          commit('SET_CourseRequests', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  searchCourseRequest({ commit },search) {
    
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/searchCourseRequest",search)
        .then((response) => {
          commit('SET_CourseRequests', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCourseRequestByUser({ commit }) {
    
    return new Promise((resolve, reject) => {
      axios.get("api/CourseRequest/GetCourseRequestByUser")
        .then((response) => {
          commit('SET_CourseRequests', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem(context, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/CourseRequest/UpdateCourseRequest?ID="+item.ID, item)
        .then((response) => {
          //commit('UPDATE_CourseRequest', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/CourseRequest/GetCourseRequest?ID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  GetCourseRequestBudget( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/CourseRequest/GetCourseRequestBudgetByCourseRequestID?ID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SetBudgetOfCourseRequest(context, courseRequestBudget) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/SetBudgetOfCourseRequest", courseRequestBudget)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  ChangeProposalStatus(context, data) {
    return new Promise((resolve, reject) => {
      axios.post("api/ProposalStatus/ChangeProposalStatus", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      axios.delete("API/CourseRequest/DeleteCourseRequest?courseRequestID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 

  removeContact(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CourseRequest/DeleteCourseRequestContact?ID="+item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SavePaymentProof(context,pay) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/SavePaymentProof",pay)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SaveTraineePassport(context,data) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/SaveTraineePassport",data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SaveTraineeVisaProof(context,data) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/SaveTraineeVisaProof",data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SaveTraineeFlightTicket(context,data) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/SaveTraineeFlightTicket",data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SaveRequestTrainees(context,data) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/SaveRequestTrainees",data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
